@import '~style-sheet-helpers/core.less';
@import (reference) '../../constants/spacing.module.less';
@import '../../app-brand/entities/entity-layer.module.less';

.input-border-base-style() {
  border: 1px solid @product-page--input--border-color;
  &:focus-within {
    border-color: @product-page--input--focus--border-color;
  }
}

.product-details {
  width: 850px;
  height: 100%;
  background-color: @product-page--details--background-color;
}

.product-details-body {
  height: 100%;
}

.title {
  font-weight: @bold;
}

.loader {
  height: 415px;
}

.header-wrapper {
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 800px;
  }

  background-color: @product-page--header-wrapper--background-color;
  box-shadow: none;
}

.content-header-wrapper {
  background-color: @product-page--header-wrapper-body--background-color;
}

.name-type-sku {
  padding: 10px;
  display: grid;
  grid-template-columns: 45% auto 15%;

  .info {
    padding: 0 5px 5px;
    Input {
      .input-border-base-style();
    }
  }

  .product-type-info {
    padding: 5px 5px 7px 15px;
    display: flex;
    align-items: center;
    color: @product-page--name-sku-product-type--text-color;
    font-size: 14px;
  }

  .product-type {
    font-size: 14px;
    padding: 5px;
  }
}

.sub-header {
  display: flex;
  align-items: center;
  font-size: 12px;
  padding-left: 10px;

  .information {
    width: 16px;
    margin: 0 7px;
  }
}

.label {
  padding: 5px 10px;
  font-size: 14px;

  &.label-with-tooltip {
    display: flex;
    align-items: center;
    gap: 6px;
  }
}

.rightside-label,
.leftside-label {
  padding: 5px 15px 5px 5px;
  font-size: 14px;
  font-weight: 500;
}

.leftside-label {
  padding: 5px 15px 5px 0;
  display: flex;
  align-items: center;
}

.paired-options {
  display: flex;
  flex-direction: column;
}

.override {
  padding: 0 10px 10px 25px;
}

.isBundleToggle {
  padding: 20px 5px 10px;
  &.hasBundlesDisabled {
    opacity: 50%;
    padding: 20px 5px 20px 20px;
    border: 1px solid @product-page--header-wrapper--border-color;
    border-radius: 0 0 8px 8px;
  }
}

.options {
  display: flex;
}

.shipping-defaults-header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  margin: 0 10px;
  border-bottom: 1px solid @product-page--header-wrapper--border-color;

  .shipping-defaults-header-text {
    align-self: flex-end;
  }
  &.dropped {
    padding-top: 30px;
  }
}

.preset-wrapper {
  display: flex;
  font-size: 14px;
  align-items: center;

  span {
    padding-right: 10px;
  }
  select {
    padding: 5px;
  }
}

.defaults-info-message {
  display: flex;
  align-items: center;
  gap: 6px;

  padding: 5px 20px;
  font-size: 12px;
}

.shipping-options {
  display: grid;
  grid-template-columns: 33% 33% 33%;
  padding: 10px;
}

.more-options {
  display: grid;
  grid-template-columns: minmax(auto, 425px) auto;
}

.more-options .packaging-options-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column: 1 / -1;
  padding: 0;
  margin-bottom: @space-12;
  column-gap: 10px;
}

.packaging-label {
  font-size: 14px;
  font-weight: 500;
  padding: 0 @space-12 @space-8;
}

.packaging-dropdown-wrapper {
  padding: @space-0 @space-12 @space-0;
}

.input-wrapper {
  Input {
    .input-border-base-style();
  }
}

.more-options,
.customs-options {
  padding: 5px 10px 10px;

  > * {
    padding: 10px 10px 0;
    font-weight: 500;
  }
}

.customs-options {
  padding: 10px;
}

.options-dropdown-wrapper {
  padding: 5px 10px;

  > div {
    font-size: 14px;
  }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .profile-info {
    font-size: 12px;
    padding-top: 3px;
    padding-left: 5px;
    padding-bottom: 2px;
    color: @product-page--dropdown--text-color;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  select {
    padding: 5px;
  }
}

.profile-info {
  font-size: 12px;
  padding-top: 3px;
  padding-left: 5px;
  padding-bottom: 2px;
  color: @product-page--profile-info--text-color;
}

.weight-wrapper {
  padding-left: 10px;
  padding-bottom: 10px;
}

.weight-input {
  width: 75px;
  font-size: 14px;
  height: 32px;
  .input-border-base-style();
}

.size-wrapper {
  padding-left: 10px;
  padding-bottom: 10px;
}

.size-input {
  width: 60px;
  font-size: 14px;
  height: 32px;
  .input-border-base-style();
}

.footer-wrapper {
  border-top: none;
}

.footer-buttons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;

  padding: 8px 0;

  .apply-to-open-orders-checkbox {
    font-size: 14px;
    color: @product-page--footer-checkbox--text-color;
    margin-right: 15px;
  }

  button {
    margin-left: 15px;
  }
}

.required-label {
  color: @product-page--label--required--text-color;
  position: relative;
  top: -7px;
  font-size: 10px;
}

.tabs {
  display: flex;
  border-bottom: 1px solid @product-page--tabs--border-color;
  padding-left: 20px;
  font-size: 14px;

  > * {
    padding: 10px;
    cursor: pointer;
  }

  > .selected {
    border: 1px solid @product-page--tabs--border-color;
    border-bottom: 2px solid @product-page--tabs--selected--border-color;
    margin-bottom: -1px;
    border-radius: 4px 4px 0 0;
    background-color: @product-page--tabs--selected--background-color;
  }
}

.tab-wrapper {
  min-height: 425px;
  overflow: auto;
}

.active-input {
  margin-left: auto;
}

.no-customs-options {
  padding-bottom: 15px;
  font-weight: 400;
}

.origin-country {
  width: 250px;

  select {
    padding: 5px;
  }
}

.paired-input {
  width: 250px;
}

.harmonization-input-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: @space-12;
  width: 100%;
}

.dropdown-picker {
  padding: 7px 10px 8px;
  font-size: 14px;
  line-height: 1.1;
  font-weight: 400;
}

.currency-input {
  height: 36px;
  .input-border-base-style();
}

.toggler-text {
  align-items: center;
  border-radius: 5px;
  height: 30px;
  min-width: 45px;
  padding: 12px 10px;
  font-size: 14px;
}

.product-type-drop {
  height: 32px;
}

.auto-split-dropdown {
  max-width: 420px;
}

.icon {
  height: 12px;
  width: 12px;
  margin-left: 4px;
}

.byol-banner {
  width: calc(100% - 40px);
  margin: 10px 20px;
}

.add-component-button {
  display: flex;
  flex-flow: row;
  gap: @space-8;
  align-items: center;
}

.fulfillment-rates-product-fee {
  padding: @space-8 @space-12;
  font-size: 12px;
  display: block;
  white-space: normal;
  border-top: 1px solid @product-page--header-wrapper--border-color;
  margin: 0 @space-12;
}

.fulfillment-rates-product-fee > * {
  margin-bottom: @space-8;
  display: block;
}

.enable-fulfillment-rates-header {
  font-weight: 500;
  font-size: 14px;
  padding-top: @space-16;
}

.dg-section {
  padding: @space-0 @space-24;
}

.dg-section-title {
  font-size: 14px;
}

.dg-section-set-dg-checkbox {
  padding: @space-8 @space-0;
}

.dangerous-goods-details {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-16;
  padding: @space-8 @space-0 @space-16 @space-24;
}

.divider {
  border-color: var(--default--border-color--10);
}

.validation-error {
  color: var(--red-600);
  margin-top: @space-4;
}
